/*export const LOGIN_WITH_PROVIDER = 'USER/LOGIN_WITH_PROVIDER'
export const START_AUTH = 'USER/START_AUTH'
export const START_LOGIN_WITH_PROVIDER = 'USER/START_LOGIN_WITH_PROVIDER'
export const DONE_LOGIN_WITH_PROVIDER = 'USER/DONE_LOGIN_WITH_PROVIDER'
export const START_SESSION_RESTORE = 'USER/START_SESSION_RESTORE';
export const FINISH_SESSION_RESTORE = 'USER/FINISH_SESSION_RESTORE';*/
export const START_LOADING_DETAILS = 'USER/START_LOADING_DETAILS';
export const DONE_LOADING_DETAILS = 'USER/DONE_LOADING_DETAILS';